import { useMutation, useQuery } from 'react-query';
import axios from 'axios';

export const cartMutation = () => {
  return useMutation(({ items }) => {
    return axios.post('/cart/add.js', {
      items,
    });
  });
};

export const useCartUpdate = () => {
  return useMutation(({ updates }) => {
    return axios.post('/cart/update.js', {
      updates,
      // items,
    });
  });
};

export const useUpdateNotes = () => {
  return useMutation(( note ) => {
    return axios.post('/cart/update.js', {
      note
    });
  });
};

export const useCartContents = () => {
  return useQuery('cart', async () => {
    const { data } = await axios.get('/cart.js');
    return data;
  });
};
